import { useQuery } from '@apollo/client';
import type { Topic } from '@communities/content-management/domain';
import { GET_COMMUNITY_TOPICS } from '@communities/content-management/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunityTopicsResponse {
  community: {
    id: string;
    topics: Topic[];
  } | null;
}

export function useCommunityTopics(communityId?: string) {
  const { data, loading, error, refetch } = useQuery<CommunityTopicsResponse>(GET_COMMUNITY_TOPICS, {
    variables: { communityId },
    fetchPolicy: 'cache-first',
    skip: !communityId,
  });

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  const topics: Topic[] = data?.community?.topics || [];

  return {
    topics,
    loading,
    errors,
    refetch,
  };
}

export default useCommunityTopics;
